module.exports = __webpack_public_path__ + "static/media/digital-key_1.0045e261.svg";